import type { HvyModule, HvyMount } from './hvy-types';
import { pageLayout } from './layout';

export async function renderAnalysisPage(root: HTMLElement): Promise<void> {
  root.innerHTML = pageLayout('Survey Analysis', `
    <section class="survey-card analysis-document">
      <div id="analysisLoading" class="loading-state"><span class="spinner"></span>Loading the survey analysis…</div>
      <div id="analysisMount" class="survey-mount"></div>
    </section>`, { publicNav: true, showAbout: false, showHeading: false });

  const loading = root.querySelector<HTMLElement>('#analysisLoading')!;
  const mountRoot = root.querySelector<HTMLElement>('#analysisMount')!;
  let mount: HvyMount | null = null;

  try {
    const hvyModuleUrl = __HVY_EMBED_URL__;
    const [hvy, response] = await Promise.all([
      import(/* @vite-ignore */ hvyModuleUrl) as Promise<HvyModule>,
      fetch('/Survey-analysis.hvy'),
    ]);
    if (!response.ok) throw new Error('The survey analysis file could not be loaded.');
    const document = hvy.deserializeDocumentBytes(new Uint8Array(await response.arrayBuffer()), '.hvy');
    mount = hvy.mountHvyViewer({
      root: mountRoot,
      document,
      plugins: [hvy.plugins.editableText, hvy.plugins.qrCode, hvy.plugins.scripting],
      controls: false,
      persistSessionState: false,
    });
    loading.hidden = true;
    loading.style.display = 'none';
  } catch (error) {
    mount?.destroy();
    loading.className = 'error-state';
    loading.textContent = error instanceof Error ? error.message : 'The survey analysis could not be loaded.';
  }
}
